import React, { useEffect, useState } from "react";
import { Button, Card, Form, ListGroup, Modal } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import * as authActions from "../../../redux/actions/authAction";
import parse from "html-react-parser";
import { useNavigate } from "react-router-dom";
// import {socket} from "../../../constants/socket";

const Dashboard = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [dailyContentModal, setDailyContentModal] = useState(false);
  const [reminderModal, setReminderModal] = useState(false);
  const [upcomingContentModal, setUpcomingContentModal] = useState(false);
  const [contentData, setContentData] = useState("");
  useEffect(() => {
    dispatch(authActions.getDashboardData());
    dispatch(authActions.getActivityData());
    dispatch(authActions.getUserAssignedCoach());
    dispatch(authActions.getDailyContent());
    dispatch(authActions.getReminderData(callBackForDailyReminder));
    dispatch(authActions.getLastDoneActivties());
  }, []);

  const {
    userDashboardData,
    reminderDataInReducer,
    DailyContentData,
    lastDoneActivities,
  } = useSelector((state) => state.getDashboardData);

  const callBackForDailyReminder = (res) => {
    if (res?.data?.length) {
      setReminderModal(true);
    }
  };
  const onAwarenessContentModal = (data) => {
    if (data?.category === "Activity") {
      dispatch(
        authActions.getSingleActivityData(data?._id, callBackForSingleActivity)
      );
    } else {
      setDailyContentModal(true);
      dispatch(
        authActions.markContentSeen(data._id, callBackForMarkSeenContent)
      );

      setContentData(data);
    }
  };
  const callBackForSingleActivity = (res) => {
    navigate("/activities", {
      state: { dataFromDashboard: res },
    });
  };
  const callBackForMarkSeenContent = (res) => {
    if (res.status === 200) {
      dispatch(authActions.getDashboardData());
    }
  };
  const ondailyContentModalClose = () => {
    setDailyContentModal(false);
  };
  const onUpcomingContentModal = (data) => {
    if (data?.category === "Activity") {
      dispatch(
        authActions.getSingleActivityData(data?._id, callBackForSingleActivity)
      );
    } else {
      setUpcomingContentModal(true);
      dispatch(
        authActions.markContentSeen(data._id, callBackForMarkSeenContent)
      );
      setContentData(data);
    }
  };
  const onUpcomingContentModalClose = () => {
    setUpcomingContentModal(false);
  };
  const onReminderModalClose = () => {
    setReminderModal(false);
    const seenReminderData = {
      reminderSeen: true,
    };
    dispatch(authActions.reminderCloser(seenReminderData));
  };
  return (
    <>
      <>
        {/* Awareness content modal*/}
        <Modal
          size="lg"
          backdrop="static"
          className="p-0"
          keyboard={false}
          data-dismiss="modal"
          show={dailyContentModal}
          onHide={ondailyContentModalClose}
          centered
        >
          <Modal.Header className="modal-header-workout" closeButton>
            <Modal.Title>{contentData?.title}</Modal.Title>
          </Modal.Header>
          <Modal.Body className="add-question-modal-body">
            {contentData ? <>{parse(contentData?.content)}</> : null}
          </Modal.Body>
          {/* <Modal.Footer>
              <Button variant="secondary" onClick={onAddQuestionModalClose}>
                Cancel
              </Button>
              <Button variant="primary" onClick={onAddUserhandler}>
                Save
              </Button>
            </Modal.Footer> */}
        </Modal>
      </>
      <>
        {/*Reminder modal*/}
        <Modal
          size="lg"
          backdrop="static"
          className="p-0"
          keyboard={false}
          data-dismiss="modal"
          show={reminderModal}
          onHide={onReminderModalClose}
        >
          <Modal.Header className="modal-header-workout" closeButton>
            <Modal.Title>Daily reminder</Modal.Title>
          </Modal.Header>
          <Modal.Body className="add-question-modal-body">
            {reminderDataInReducer?.data}
          </Modal.Body>
        </Modal>
      </>
      <>
        {/* Upcoming content modal*/}
        <Modal
          size="lg"
          backdrop="static"
          className="p-0"
          keyboard={false}
          data-dismiss="modal"
          show={upcomingContentModal}
          onHide={onUpcomingContentModalClose}
          centered
        >
          <Modal.Header className="modal-header-workout" closeButton>
            <Modal.Title>{contentData?.title}</Modal.Title>
          </Modal.Header>
          <Modal.Body className="add-question-modal-body">
            {contentData ? <>{parse(contentData?.content)}</> : null}
          </Modal.Body>
          {/* <Modal.Footer>
              <Button variant="secondary" onClick={onAddQuestionModalClose}>
                Cancel
              </Button>
              <Button variant="primary" onClick={onAddUserhandler}>
                Save
              </Button>
            </Modal.Footer> */}
        </Modal>
      </>
      <div className="dashboard pb-5 px-5">
        <div className="goals">
          <Card className="p-4">
            <h4 className="d-flex font-weight-bold"> Your Goals</h4>
            <Card.Body className="dashboard-goals-container">
              {userDashboardData?.data?.length ? (
                <>
                  {userDashboardData?.data?.map((val, index) => {
                    return (
                      <div
                        key={index}
                        className="row dashboard-goals-card py-4"
                      >
                        <div className="col-1">
                          <div className="goal-img-rested">
                            <img
                              src="/img/CheckboxTick.png"
                              alt="img"
                              className="goalDefaultImg"
                            />
                          </div>
                        </div>
                        <div className="col-11">
                          <div className="progress-bar-and-goal d-flex justify-content-between mb-1">
                            <div className="dashboardProgressTitle ">
                              {val.title}
                            </div>
                            <div className="dashboardProgressDays">
                              {/* Progress {val.progress.toString().split(".")[0]}{" "} */}
                              Progress 90 Days
                            </div>
                          </div>
                          <div className="progress">
                            <div
                              className="progress-bar"
                              role="progressbar"
                              style={{ width: val.progress + "%" }}
                              aria-valuenow="25"
                              aria-valuemin="0"
                              aria-valuemax="100"
                            ></div>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </>
              ) : (
                <>
                  <h5>No goals yet</h5>
                </>
              )}
            </Card.Body>
          </Card>
        </div>

        <div className="row mt-4">
          <div className="col-md-4">
            <Card className="downcard-main-container">
              <div className="awareness dashboard-downcards">
                <div className="d-flex cards-header">
                  <img src="/img/aware.png" alt="img" />
                  <h5 className="content-name ms-4 font-weight-bold">
                    Today's Content
                  </h5>
                </div>
                {DailyContentData?.data?.todayContents?.length ? (
                  <div>
                    {DailyContentData?.data?.todayContents.map(
                      (data, index) => {
                        return (
                          <h6
                            className="border-bottom daily-content-title d-flex py-4"
                            onClick={() => {
                              if (data?.contentDetail?.title !== undefined) {
                                onAwarenessContentModal(data?.contentDetail);
                              }
                            }}
                          >
                            {data?.contentDetail?.title
                              ? data?.contentDetail?.title
                              : "No content yet"}
                          </h6>
                        );
                      }
                    )}
                  </div>
                ) : (
                  <div className="mb-5 mt-5"> No content yet</div>
                )}
              </div>
            </Card>
          </div>
          <div className="col-md-4">
            <Card className="downcard-main-container">
              <div className="upcoming dashboard-downcards">
                <div className="d-flex cards-header">
                  <img src="/img/calendar.png" alt="img" />
                  <h5 className="content-name ms-4 font-weight-bold ">
                    Tomorrow's content
                  </h5>
                </div>
                {DailyContentData?.data?.upCommingContents?.length ? (
                  <div>
                    {DailyContentData?.data?.upCommingContents?.map(
                      (data, index) => {
                        return (
                          <h6
                            className="border-bottom daily-content-title d-flex py-4"
                            onClick={() => {
                              if (data?.contentDetail?.title !== undefined) {
                                onUpcomingContentModal(data?.contentDetail);
                              }
                            }}
                          >
                            {data?.contentDetail?.title
                              ? data?.contentDetail?.title
                              : "No content yet"}
                          </h6>
                        );
                      }
                    )}
                  </div>
                ) : (
                  <div className="mb-5 mt-5"> No content yet</div>
                )}
              </div>
            </Card>
          </div>
          <div className="col-md-4 activities">
            <Card className="downcard-main-container">
              <div className="dashboard-downcards">
                <div className="d-flex cards-header">
                  <img src="/img/tick.png" alt="img" />
                  <h5 className="content-name ms-4 font-weight-bold">
                    Last Activities
                  </h5>
                </div>
                {lastDoneActivities?.data?.length ? (
                  <div>
                    {lastDoneActivities?.data?.map((data, index) => {
                      return (
                        <h6 className="border-bottom daily-content-title d-flex py-4">
                          {data?.title ? data?.title : "No content yet"}
                        </h6>
                      );
                    })}
                  </div>
                ) : (
                  <div className="mb-5 mt-5"> No content yet</div>
                )}
              </div>
            </Card>
          </div>
        </div>
      </div>
    </>
  );
};
export default Dashboard;
